import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=8f0380a0&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=ts&"
export * from "./profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0380a0",
  null
  
)

export default component.exports